/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BasicListWithColumnsAndConnectionsAndEnrichmentCountDto } from '../models/BasicListWithColumnsAndConnectionsAndEnrichmentCountDto';
import type { CrmConnectionsStatusDto } from '../models/CrmConnectionsStatusDto';
import type { ExportListItemsResultDto } from '../models/ExportListItemsResultDto';
import type { GetListItemsResultDto } from '../models/GetListItemsResultDto';
import type { GetListsResultDto } from '../models/GetListsResultDto';
import type { ListColumnDto } from '../models/ListColumnDto';
import type { UpdateListColumnsDto } from '../models/UpdateListColumnsDto';
import type { UpdateListItemOrderDto } from '../models/UpdateListItemOrderDto';
import type { UpdateListRequestDto } from '../models/UpdateListRequestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ListsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns GetListsResultDto
     * @throws ApiError
     */
    public getAll({
        typesArray,
        itemsPerPage,
        page,
        query,
    }: {
        typesArray: Array<'STATIC' | 'DYNAMIC' | 'AI'>,
        itemsPerPage: number,
        page: number,
        query?: string | null,
    }): CancelablePromise<GetListsResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/lists',
            query: {
                'query': query,
                'types[]': typesArray,
                'items_per_page': itemsPerPage,
                'page': page,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public delete({
        idsArray,
    }: {
        idsArray: Array<string>,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/lists',
            query: {
                'ids[]': idsArray,
            },
        });
    }
    /**
     * @returns BasicListWithColumnsAndConnectionsAndEnrichmentCountDto
     * @throws ApiError
     */
    public get({
        id,
    }: {
        id: string,
    }): CancelablePromise<BasicListWithColumnsAndConnectionsAndEnrichmentCountDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/lists/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public update({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: UpdateListRequestDto,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/lists/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public connectHubspot({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/lists/{id}/crm/hubspot',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public disconnectHubspot({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/lists/{id}/crm/hubspot',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns CrmConnectionsStatusDto
     * @throws ApiError
     */
    public hubspotConnectionStatus({
        id,
    }: {
        id: string,
    }): CancelablePromise<CrmConnectionsStatusDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/lists/{id}/crm/hubspot/status',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns GetListItemsResultDto
     * @throws ApiError
     */
    public getItems({
        id,
        itemsPerPage,
        page,
        query,
    }: {
        id: string,
        itemsPerPage: number,
        page: number,
        query?: string | null,
    }): CancelablePromise<GetListItemsResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/lists/{id}/companies',
            path: {
                'id': id,
            },
            query: {
                'query': query,
                'items_per_page': itemsPerPage,
                'page': page,
            },
        });
    }
    /**
     * @returns ExportListItemsResultDto
     * @throws ApiError
     */
    public export({
        id,
    }: {
        id: string,
    }): CancelablePromise<ExportListItemsResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/lists/{id}/export',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ListColumnDto
     * @throws ApiError
     */
    public updateColumns({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: UpdateListColumnsDto,
    }): CancelablePromise<Array<ListColumnDto>> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/lists/{id}/columns',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ListColumnDto
     * @throws ApiError
     */
    public getColumns({
        id,
    }: {
        id: string,
    }): CancelablePromise<Array<ListColumnDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/lists/{id}/columns',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public dismissUnmatchedItemsNotice({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/lists/{id}/dismiss-unmatched-items-notice',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public updateOrder({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: UpdateListItemOrderDto,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/lists/{id}/companies/order',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
